export function normalizeMobile(input) {
  const digits = String(input || '').replace(/\D/g, '');
  const normalized = digits.length === 11 && digits[0] === '1' ? digits.slice(1) : digits;
  return normalized.length === 10 && /^\d{10}$/.test(normalized) ? normalized : null;
}
